import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useModalContext } from '../../contexts/ModalContext';
import { useLogout } from '../../hooks/useLogout';
import AppModal from './Modal';

const ModalExpired = () => {
    const { t } = useTranslation();
    const { expired, setExpired } = useModalContext();
    const { logout } = useLogout();
    const navigate = useNavigate();

    const goHome = () => {
        logout();
        setExpired(false);
        navigate('/');
    };

    if (!expired) return <></>;

    return (
        <AppModal
            safeAction={goHome}
            safeText={t('login.sign_in') as string}
        >
            <p>{t('feedback.session_expired')}</p>
        </AppModal>
    );
};

export default ModalExpired;
